__webpack_require__.p = "ocgp-games-ui/dist/";